export const DEFAULT_CATEGORY = "All"